import { Instance } from 'mobx-state-tree';
import { DeleteDriverPushTokenDtoModelBase } from './DeleteDriverPushTokenDtoModel.base';

/* The TypeScript type of an instance of DeleteDriverPushTokenDtoModel */
export interface DeleteDriverPushTokenDtoModelType extends Instance<typeof DeleteDriverPushTokenDtoModel.Type> {}

/* A graphql query fragment builders for DeleteDriverPushTokenDtoModel */
export { selectFromDeleteDriverPushTokenDto, deleteDriverPushTokenDtoModelPrimitives, DeleteDriverPushTokenDtoModelSelector } from './DeleteDriverPushTokenDtoModel.base';

/**
 * DeleteDriverPushTokenDtoModel
 */
export const DeleteDriverPushTokenDtoModel = DeleteDriverPushTokenDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
